var _g, _defs, _defs2, _defs3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgProfile = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 116,
  height: 96,
  viewBox: "0 0 116 96",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#profile_svg__filter0_ddi_4437_2070)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M74.3999 58.16C74.2999 58.09 89.6999 21.78 57.9999 18C26.6199 23.2 41.6999 58.09 41.5999 58.16C29.6699 66.09 29.9999 71.66 29.9999 71.66C38.0999 78.07 57.9999 78 57.9999 78C57.9999 78 77.8999 78.08 85.9999 71.66C85.9999 71.66 86.3299 66.09 74.3999 58.16ZM57.9999 57.98C57.9999 57.98 51.5199 57.01 51.5199 53.98C51.5199 50.95 57.9999 51.32 57.9999 51.32C57.9999 51.32 64.4799 50.93 64.4799 53.98C64.4799 57.03 57.9999 57.98 57.9999 57.98ZM70.0399 41.42C68.9299 42.72 67.3099 43.44 65.6799 43.5C64.5299 43.55 63.3899 43.24 62.3799 42.67C61.4299 42.14 60.7499 41.25 59.8299 40.68C59.6999 40.6 57.9999 39.99 57.9999 40.17C57.9999 39.99 56.2999 40.6 56.1699 40.68C55.2599 41.25 54.5699 42.13 53.6199 42.67C52.6099 43.24 51.4699 43.55 50.3199 43.5C48.6899 43.43 47.0799 42.71 45.9599 41.42C45.1799 40.51 44.5399 39.19 44.5799 37.92C44.6099 36.91 45.1599 36.15 45.8799 35.56C47.1399 34.52 48.7099 33.92 50.2999 33.89C52.7299 33.84 55.1999 34.97 57.3899 35.98C57.5999 36.07 57.7999 36.17 57.9999 36.27C58.1999 36.17 58.4099 36.07 58.6099 35.98C60.7999 34.97 63.2699 33.84 65.6999 33.89C67.2899 33.92 68.8599 34.52 70.1199 35.56C70.8299 36.15 71.3799 36.91 71.4199 37.92C71.4599 39.19 70.8199 40.51 70.0399 41.42Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "profile_svg__filter0_ddi_4437_2070",
  x: -0.000976562,
  y: -12,
  width: 116.002,
  height: 120,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.346112 0 0 0 0 0.344375 0 0 0 0 0.483333 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4437_2070"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 15
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_4437_2070",
  result: "effect2_dropShadow_4437_2070"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect2_dropShadow_4437_2070",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect3_innerShadow_4437_2070"
})))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "profile_svg__gray",
  x1: 30,
  y1: 18,
  x2: 86,
  y2: 80.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.15625,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.265625,
  stopColor: "#C4C3DD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3125,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.46875,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.515625,
  stopColor: "#C4C3DD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.604167,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.875,
  stopColor: "#CECEE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.973958,
  stopColor: "white"
})))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "profile_svg__yellow",
  x1: 30,
  y1: 18,
  x2: 86,
  y2: 80.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.15625,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.265625,
  stopColor: "#FFDD9A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3125,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.46875,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.515625,
  stopColor: "#FFDD9A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.604167,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.875,
  stopColor: "#FFDD9A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.973958,
  stopColor: "white"
})))));
export { SvgProfile as ReactComponent };
export default __webpack_public_path__ + "assets/icons/profile.361579.svg";